
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, IValidatingObject } from './../../../scripts/formcontrols'
import { MedProfileDto, MedRoundDto, PatientDispensationStatus, WardCycleDto } from "./../../../dto/Dtos"

import Dal from './../../../scripts/dataaccess';
import { PatientDto } from '../../../dto/PatientDto';

class MedProfileItemController extends FormPageValidator {
    public medProfile: MedProfileDto;
    
    public taken           : FormElementController<number>;
    public returned        : FormElementController<number>;
    public destroyed       : FormElementController<number>;
    public received        : FormElementController<number>;
    public broughtForward  : FormElementController<number>;
    public carryForward    : FormElementController<number>;
    public broughtForwardOverride: boolean;
    public dispensationItemId: string;

    public checkedIn: boolean;

    get changed(): boolean {
        return this.broughtForwardChanged
            //|| this.carryForwardChanged
            || this.takenChanged
            || this.returnedChanged
            || this.destroyedChanged
            || this.checkedIn != this.medProfile.checkedIn;
    }

    get broughtForwardChanged(): boolean {
        var broughtForward = this.medProfile.broughtForwardUserOverride ? this.medProfile.broughtForward : this.medProfile.expectedBroughtForward;
        return this.broughtForward.value != broughtForward;
    }
    get takenChanged(): boolean {
        return this.taken.value != this.medProfile.taken;
    }
    get returnedChanged(): boolean {
        return this.returned.value != this.medProfile.returned;
    }
    get destroyedChanged(): boolean {
        return this.destroyed.value != this.medProfile.destroyed;
    }
    //get carryForwardChanged(): boolean {
    //    return this.carryForward.value != this.medProfile.carryForward;
    //}

    get carryForwardCalculated(): number {
        return +this.broughtForward.value + (+this.received.value) - this.destroyed.value - this.taken.value - this.returned.value;
    }

    constructor(dto: MedProfileDto) {
        super();

        this.medProfile = dto;


        this.taken            = new FormElementController<number>("taken", this.medProfile.taken           );
        this.returned         = new FormElementController<number>("returned", this.medProfile.returned        );
        this.destroyed        = new FormElementController<number>("destroyed", this.medProfile.destroyed       );
        this.received         = new FormElementController<number>("received", this.medProfile.received);

        var broughtForward  = this.medProfile.broughtForwardUserOverride ? this.medProfile.broughtForward : this.medProfile.expectedBroughtForward;

        this.broughtForward = new FormElementController<number>("broughtForward ", broughtForward  );
        this.carryForward     = new FormElementController<number>("carryForward", this.medProfile.carryForward);
        this.checkedIn = this.medProfile.checkedIn;
        this.dispensationItemId = this.medProfile.dispensationItemId;
        this.broughtForwardOverride = this.medProfile.broughtForwardUserOverride;
    }



    public GetUpdatedObject(): MedProfileDto {

        var updated = Object.assign({}, this.medProfile) as MedProfileDto;

        updated.taken               = this.taken.value;
        updated.returned            = this.returned.value;
        updated.destroyed           = this.destroyed.value;
        updated.received            = this.received.value;
        updated.broughtForward      = this.broughtForward.value;
        updated.carryForward        = this.carryForward.value;
        updated.dispensationItemId  = this.dispensationItemId;
        updated.checkedIn = this.checkedIn;
        this.broughtForwardOverride = this.broughtForwardChanged;
        updated.broughtForwardUserOverride = this.broughtForwardOverride;

        return updated;
    }
}


export default class MedProfileController extends FormPageValidator {

    public Items: Array<MedProfileItemController>;
    public patientId: string;

    public startDate: Date;
    public endDate: Date;
    public Patient: PatientDto;
    public Cycles: Array<WardCycleDto>;
    public CurrentStartDate: Date;
    public CurrentEndDate: Date;
    public CurrentCycleTitle: string;

    constructor(patientId :string) {
        super();
        this.patientId = patientId;
        this.Items = new Array<MedProfileItemController>();
        this.Initialize(this.patientId);
    }

    public Initialize(patientId : string) {
        var dal = new Dal(); 
        var that = this;
        dal.GetPatient(patientId).then(p => {
            this.Patient = p;

            dal.GetWardCycles(this.Patient.wardId).then(cycles => {
                var sortedCycles = cycles.sort((n1, n2) => {
                    if (n1.startDate > n2.startDate) return -1;
                    else if (n1.startDate < n2.startDate) return 1;
                    else return 0;
                });

                this.Cycles = sortedCycles;
                that.CurrentStartDate = sortedCycles[1].startDate;
                that.CurrentEndDate = sortedCycles[1].endDate;
                that.CurrentCycleTitle = "Current Cycle"

                //this.controlLoading = false;
                that.Load();
                //this.isLoading = false;
            });
        });
    }

    public Load() {
        

        var dal = new Dal();
        this.Items = [];

        dal.GetMedProfile(this.patientId, this.CurrentStartDate, this.CurrentEndDate).then(data => {
            console.log("Med Profile ", data);
            for (var item of data) {
                this.Items.push(new MedProfileItemController(item));
            }
        });
    }


    public setCycle(cycle: WardCycleDto) {
        this.CurrentCycleTitle = this.Cycles.indexOf(cycle) == 0 ? "Next Cycle" : this.Cycles.indexOf(cycle) == 1 ? "Current Cycle" : " Cycle";
        this.CurrentStartDate    = cycle.startDate;
        this.CurrentEndDate      = cycle.endDate;
        this.Load();

    }
    public async Reload() : Promise<any>{
        var dal = new Dal();
        this.Items = [];

        return dal.GetMedProfile(this.patientId, this.CurrentStartDate, this.CurrentEndDate).then(data => {
            console.log("Med Profile ", data);
            for (var item of data) {
                this.Items.push(new MedProfileItemController(item));
            }
        });
    }

    public async Save() : Promise<Boolean> {
        var dal = new Dal();
        var result = new Array<MedProfileDto>();
        for (var item of this.Items) {
            result.push(item.GetUpdatedObject());
        }
        console.log(result);
        //return Promise.resolve(true);   
        return dal.SaveMedProfile(this.patientId, this.CurrentStartDate, this.CurrentEndDate, result).then(async (r) => {
            if (result) {
                return this.Reload().then(() => true);
            }
            return Promise.resolve(r);
        });
    }


    public CheckinAllItems() {
        for (var item of this.Items) {
            item.checkedIn = true;
        }
    }

    get ChangeCount(): number {
        return this.Items.filter(i => i.changed).length;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/PatientMedProfileForm/medProfileController.ts